module.exports = __webpack_public_path__ + "media/en_us_s2_Earl.09d0ada6.oga";